import { createClient } from '@/shared/api';
import UPDATE_SUMMARY_REPORT_MUTATION from '@/entities/report/api/mutations/updateSummaryReport';
import type {
  UpdateSummaryReportMutation,
  UpdateSummaryReportMutationVariables,
} from '@/shared/api/generated/graphql';

export type UpdateSummaryReportResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the SummaryReportDataInput GraphQL input once its server-side shape is documented
/**
 * Saves edits made to a report's summary section. Runs the updateSummaryReport mutation and throws the server message unless isSuccess is set.
 *
 * @param input - Mutation input carrying the summary edits.
 * @returns A promise resolving to the updateSummaryReport result.
 */
const handleUpdateSummaryReport = async (input: any) => {
  const client = await createClient();
  const updateSummaryReportResult = await client.mutate<
    UpdateSummaryReportMutation,
    UpdateSummaryReportMutationVariables
  >({
    mutation: UPDATE_SUMMARY_REPORT_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = updateSummaryReportResult;
  const { updateSummaryReport } = data;
  if (!updateSummaryReport.isSuccess) {
    throw new Error(updateSummaryReport.message);
  } else {
    return updateSummaryReport;
  }
};

export default handleUpdateSummaryReport;
